import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { endpoints } from "../Constants/endpoints";
import { IAppState, ApiRequest } from "../../Common";
import { Workflow } from "../Models/Workflow";

interface IWorkflowAction extends Action {
  type: WorkflowActionType;
  payload: any;
}

// ARGUMENT TYPES

export interface IGetWorkflowArguments {
  code: string;
}
export interface IUnloadWorkflowArguments {}
export interface ISetWorkflowLoadingArguments {}
export interface ISetWorkflowErroredArguments {
  errorMessage: string;
  errorCode: number;
}

// PAYLOAD TYPES

// Payload for the WORKFLOW_LOADED action, contains the loaded workflow
export interface IWorkflowLoadedPayload {
  loadedWorkflow: Workflow;
}

// Payload for the WORKFLOW_UNLOAD action
export interface IUnloadWorkflowPayload {}

// Payload for the WORKFLOW_SET_LOADING action
export interface ISetWorkflowLoadingPayload {}

// Payload for the WORKFLOW_SET_ERRORED action
export interface ISetWorkflowErroredPayload {
  errorMessage: string;
  errorCode: number;
}

// ACTION TYPES

// Action for the WORKFLOW_LOADED action
export interface IWorkflowLoadedAction extends IWorkflowAction {
  payload: IWorkflowLoadedPayload;
}

// Action for the WORKFLOW_UNLOAD action
export interface IUnloadWorkflowAction extends IWorkflowAction {
  payload: IUnloadWorkflowPayload;
}

// Action for the WORKFLOW_SET_LOADING action
export interface ISetWorkflowLoadingAction extends IWorkflowAction {
  payload: ISetWorkflowLoadingPayload;
}

// Action for the WORKFLOW_SET_ERRORED action
export interface ISetWorkflowErroredAction extends IWorkflowAction {
  payload: ISetWorkflowErroredPayload;
}

// Union of all action types. If you define a new action type, add it here...
export type WorkflowAction =
  | IWorkflowLoadedAction
  | IUnloadWorkflowAction
  | ISetWorkflowLoadingAction
  | ISetWorkflowErroredAction;

export enum WorkflowActionType {
  WORKFLOW_LOADED = "WORKFLOW_LOADED",
  WORKFLOW_UNLOAD = "WORKFLOW_UNLOAD",
  WORKFLOW_SET_LOADING = "WORKFLOW_SET_LOADING",
  WORKFLOW_SET_ERRORED = "WORKFLOW_SET_ERRORED"
}

export const setErrored = (args: ISetWorkflowErroredArguments): ISetWorkflowErroredAction => ({
  type: WorkflowActionType.WORKFLOW_SET_ERRORED,
  payload: { ...args }
});

// Gets workflow from the server asynchronously and dispatches a WORKFLOW_LOADED action when complete, or a WORKFLOW_SET_ERRORED action if the get failed
export const getWorkflow = (
  args: IGetWorkflowArguments
): ThunkAction<
  void,
  IAppState,
  {},
  IWorkflowLoadedAction | ISetWorkflowErroredAction
> => dispatch => {
  ApiRequest.fromPath(endpoints.get(args.code))
    .withAuthHeader()
    .get()
    .then(response => response.json())
    .then(json => {
      if (json.status === undefined) {
        // this was successful
        dispatch({
          type: WorkflowActionType.WORKFLOW_LOADED,
          payload: {
            loadedWorkflow: json.payload
          }
        });
      } else {
        // this failed
        dispatch(
          setErrored({
            errorMessage: json.error.message,
            errorCode: json.status
          })
        );
      }
    });
};

export const unloadWorkflow = (args: IUnloadWorkflowArguments): IUnloadWorkflowAction => ({
  type: WorkflowActionType.WORKFLOW_UNLOAD,
  payload: { ...args }
});

export const setLoading = (args: ISetWorkflowLoadingArguments): ISetWorkflowLoadingAction => ({
  type: WorkflowActionType.WORKFLOW_SET_LOADING,
  payload: { ...args }
});
